/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { BrokerResponseDto } from './brokerResponseDto';
import type { BrokersListMetadataDto } from './brokersListMetadataDto';

export interface BrokersListResponseDto {
  data: BrokerResponseDto[];
  metadata: BrokersListMetadataDto;
}
